import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { sortByKeys } from '../../../helpers/array.helper';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';

export default function SelectProveedor(props) {
  const {
    defaultValue, selection, values, loading, keys: { id, descripcion }, onSelect, visible, sortBy, filterBy,
  } = props;
  const sortedValues = sortByKeys(sortBy, values);
  return (
    <ShowIf condition={visible || visible === undefined}>
      <Select
        showSearch={filterBy !== null}
        placeholder="Seleccione un proveedor"
        size="large"
        defaultValue={defaultValue}
        value={selection ? selection : undefined}
        loading={loading}
        onSelect={selection => onSelect(selection)}
        style={{ width: '100%' }}
        filterOption={(input, { props: optionProps }) => (optionProps.children.toLowerCase().indexOf(input.toLowerCase()) >= 0)}
      >
        {sortedValues.map(value => <Select.Option value={value[id]}>{value[descripcion]}</Select.Option>)}
      </Select>
    </ShowIf>
  );
}
SelectProveedor.propTypes = {
  defaultValue: PropTypes.shape({}),
  loading: PropTypes.bool,
  visible: PropTypes.bool,
  filterBy: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.shape({})),
  sortBy: PropTypes.arrayOf(PropTypes.shape({})),
  keys: { id: PropTypes.string, descripcion: PropTypes.string },
  selection: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
};
SelectProveedor.defaultProps = {
  values: [],
  defaultValue: null,
  loading: false,
  keys: { id: 'id', descripcion: 'descripcion' },
  sortBy: {},
  selection: null,
  visible: true,
  filterBy: null,
  onSelect: () => {},
};
